<template>
    <div>
        <div class="d-flex-center py-5">
            <img src="@/assets/report/monthly.png">
        </div>
        <v-container>
            <v-row>
                <v-col cols="12" class="pb-0">
                    <v-row class="d-flex-center" style="gap: 10px;">
                        <div>
                            <v-menu
                                v-model="startDatePickerShow"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="startDateFormatted"
                                        :label="$vuetify.lang.t('$vuetify.statusAttendance.startDate')"
                                        prepend-inner-icon="event"
                                        @click:prepend-inner="startDatePickerShow = true"
                                        @click:clear="startDate = null"
                                        readonly
                                        v-on="on">
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    :locale="localeLang"
                                    v-model="startDate"
                                    @change="formatStartDate"
                                    @input="startDatePickerShow = false">
                                </v-date-picker>
                            </v-menu>
                        </div>
                        <div>
                            <v-menu
                                v-model="endDatePickerShow"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="endDateFormatted"
                                        :label="$vuetify.lang.t('$vuetify.statusAttendance.endDate')"
                                        prepend-inner-icon="event"
                                        @click:clear="endDate = null"
                                        @click:prepend-inner="endDatePickerShow = true"
                                        readonly
                                        v-on="on">
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    :locale="localeLang"
                                    v-model="endDate"
                                    @change="formatEndDate"
                                    @input="endDatePickerShow = false">
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-row>
                </v-col>
                <v-col cols="12" class="pt-0">
                    <v-row class="d-flex-center">
                        <v-btn
                            color="green darken-1"
                            class="ma-2 white--text"
                            width="180"
                            height="50"
                            :disabled="!canGenReport"
                            @click="submit()">
                            {{ $vuetify.lang.t('$vuetify.monthly.exportText') }}
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'TigerOT',

    props: {
        canGenReport: {
            type: Boolean,
            default: false
        },
        branchId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            startDate: this.$util.getCurrentDate(),
            endDate: this.$util.getCurrentDate(),
            startDatePickerShow: false,
            endDatePickerShow: false,
            startDateFormatted: '',
            endDateFormatted: '',
            exportPath: ''
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        }
    },

    methods: {
        formatStartDate () {
            this.startDateFormatted = this.$util.formatDate(this.startDate)
        },

        formatEndDate () {
            this.endDateFormatted = this.$util.formatDate(this.endDate)
        },

        async submit () {
            const formData = {
                startDate: this.startDateFormatted,
                endDate: this.endDateFormatted,
                branchId: this.branchId
            }

            this.$store.dispatch('setLoading', true)
            const response = await this.axios.post('report/tiger/text/ot', formData, {
                headers: {
                    'Content-Type': 'text/pain'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$util.downloadTextFile(response.data, `report-ot-${this.monthPick}.txt`)
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    mounted () {
        this.formatStartDate()
        this.formatEndDate()
    }
}
</script>

<style lang="scss" scoped>
</style>
